import { Container } from '@pixi/react';
import { gameConfigurationStore } from '../../store/gameConfigurationStore';
import { useEffect, useRef } from 'react';
import { Spine } from '../spine';

export const GameWinBoard = () => {
    const winBoardRef = useRef()


    useEffect(() => {
        const board = new Spine({ key: 'boardFrame' });
        winBoardRef.current.addChild(board)
        winBoardRef.current.x = gameConfigurationStore.reelsContainerParams.xInFigma + winBoardRef.current.width / 2;
        winBoardRef.current.y = gameConfigurationStore.reelsContainerParams.yInFigma + winBoardRef.current.height / 2
    }, [winBoardRef])


    return (
        <Container name='WinBoardContainer' pivot={0} ref={winBoardRef} />

    );
};
